import {FunctionComponent, useContext, useEffect} from 'react';

type overlayProps = {projectId:number};
const OverlayLayer: FunctionComponent<overlayProps> = (projectId) => {
    // @ts-ignore
    return null;
};

export default OverlayLayer;